import { render, staticRenderFns } from "./TasksInheritance.vue?vue&type=template&id=3f65d01c&"
import script from "./TasksInheritance.vue?vue&type=script&lang=js&"
export * from "./TasksInheritance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports